module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_9016.dfe18c0f.png";